import {
    CREATE_CHECKS_USER_FORM_ROLES,
    CREATE_ROLES_FAILURE,
    CREATE_ROLES_REQUEST,
    CREATE_ROLES_SUCCESS,
    CREATE_USER_FORM_ROLES,
    DELETE_ROLES_FAILURE,
    DELETE_ROLES_REQUEST,
    DELETE_ROLES_SUCCESS,
    FETCH_ROLES_FAILURE,
    FETCH_ROLES_REQUEST,
    FETCH_ROLES_SUCCESS,
    FETCH_SINGLE_ROLES_FAILURE,
    FETCH_SINGLE_ROLES_REQUEST,
    FETCH_SINGLE_ROLES_SUCCESS,
    ROLES_DROPDOWN_FAILURE,
    ROLES_DROPDOWN_REQUEST,
    ROLES_DROPDOWN_SUCCESS,
    ROLES_USERFORM_RESET,
    UPDATE_ROLES_FAILURE,
    UPDATE_ROLES_REQUEST,
    UPDATE_ROLES_SUCCESS
} from './roles.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

// FETCH PROPERTY MASTER
export let fetchRolesMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.rolesGET,
        responseTypeRequest: FETCH_ROLES_REQUEST,
        responseTypeSuccess: FETCH_ROLES_SUCCESS,
        responseTypeFailure: FETCH_ROLES_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createRolesUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_ROLES, payload: { key, value } });
    };
};

// export let createRolesChecksUserForm = (key) => {
//     return (dispatch) => {
//         dispatch({ type: CREATE_CHECKS_USER_FORM_ROLES, payload: { key } });
//     };
// };

//call property from property table
export let fetchRolesOrSection = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${id}`,
        responseTypeRequest: ROLES_DROPDOWN_REQUEST,
        responseTypeSuccess: ROLES_DROPDOWN_SUCCESS,
        responseTypeFailure: ROLES_DROPDOWN_FAILURE,
        payload: id
    };
    return axiosCall(config);
};
// ROLES_USERFORM_RESET
// CREATE PROPERTY MASTER
export let createRoles = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: 0,
        fldAdmin: formData.fldAdmin,
        fldFKRole: 0,
        fldRole: 'Auto Generated',
        fldIsActive: true,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString(),
        fldRoleName: formData.fldRoleName
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.rolesPOST}`,
        responseTypeRequest: CREATE_ROLES_REQUEST,
        responseTypeSuccess: CREATE_ROLES_SUCCESS,
        responseTypeFailure: CREATE_ROLES_FAILURE,
        resetFormData: ROLES_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchRolesMaster()
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleRoles = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.rolesGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_ROLES_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_ROLES_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_ROLES_FAILURE,
        singlApiArray: [fetchRolesOrSection(33), fetchRolesOrSection(34)]
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateRole = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        ...formData,
        fldAdmin: formData.fldAdmin,
        fldFKRole: parseInt(formData.fldFKRole),
        fldIsActive: true,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        FldRoleName: formData.FldRoleName
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.rolesPATCH}/${id}`,
        responseTypeRequest: UPDATE_ROLES_REQUEST,
        responseTypeSuccess: UPDATE_ROLES_SUCCESS,
        responseTypeFailure: UPDATE_ROLES_FAILURE,
        resetFormData: ROLES_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchRolesMaster()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteRole = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.rolesDELETE}/${id}`,
        responseTypeRequest: DELETE_ROLES_REQUEST,
        responseTypeSuccess: DELETE_ROLES_SUCCESS,
        responseTypeFailure: DELETE_ROLES_FAILURE,
        modalClose: true,
        getAllData: fetchRolesMaster()
    };
    return axiosCall(config);
};
